// Picking a layer for new cues or notes, and Undo / Redo, are choices made with the toolbar that are not
// tools: the tool you were using stays active (Undo and Redo, Josh 24 Oct 2026).
const KEEPS_TOOL = ['cueLayer', 'noteLayer', 'undo', 'redo'];

// eslint-disable-next-line import/prefer-default-export
export function changesActiveTool(type) {
    return KEEPS_TOOL.indexOf(type) === -1;
}


// WEBPACK FOOTER //
// ./src/lib/active-tool.js